/* global commonL10n */ import rmlOpts from "rmlopts";
/**
 * Warn the user when deleting files and give a hint while deleting shortcuts.
 */ window.rmlWarnDelete = ()=>confirm((commonL10n.warnDelete || "") + rmlOpts.others.lang.warnDelete);
